import React, { useEffect, useState } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { useNavigate } from 'react-router-dom';
//import {jwtDecode} from 'jwt-decode';
import { useLazyCompteLoginExistQuery} from "../redux/slice/api/FO/compteApi";
import { useLazyFetchUserByLoginQuery } from '../redux/slice/api/authApi';
import { resetCompte, setCompte, setErrorCompte } from "../redux/slice/compte.slice";
import { useDispatch } from "react-redux";
import { Type_Return_Message } from '../models/interfaces/IReturn_Parent';
import { toast } from 'react-toastify';


const CpntKeycloakSession = () => {

  const { initialized: keycloakinitialized,keycloak, } = useKeycloak();
  //const [isExpired, setIsExpired] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  
  useEffect(() => {
    const onTokenRefreshSuccess = () => {
      //Token was successfully refreshed
    };

    const onTokenExpired = () => {
      //Token has expired
      dispatch(resetCompte());
      keycloak.logout();
    };

    keycloak.onTokenExpired = onTokenExpired;
    keycloak.onAuthRefreshSuccess = onTokenRefreshSuccess;

    return () => {
      keycloak.onTokenExpired = undefined;
      keycloak.onAuthRefreshSuccess = undefined;
    };
  }, [keycloak,keycloak.authenticated, navigate]);

  /**/




  const [callCompteLoginExist,{data: CompteLoginExistData,error: errorCompteLoginExist}] = useLazyCompteLoginExistQuery();
  const [callUserByLogin,{data: UserByLoginData}] = useLazyFetchUserByLoginQuery();
  const [currentCompte, setcurrentCompte] = useState<string>("");


  useEffect(() => {
    if (UserByLoginData?.Return_IdType_Message === Type_Return_Message.Erreur) {
      UserByLoginData && toast.error(<div dangerouslySetInnerHTML={{ __html: UserByLoginData.Return_Message ? UserByLoginData.Return_Message : "" }} />,{autoClose:5000});
    } else if (UserByLoginData?.Return_IdType_Message === Type_Return_Message.Validation) {
      //toast.success("auth ok");
      if (UserByLoginData?.Compte) {
        dispatch(setCompte(UserByLoginData?.Compte));
      }
    }
    
  }, [UserByLoginData?.Compte])

  useEffect(() => {
    if (keycloakinitialized && keycloak.authenticated) {
        keycloak?.loadUserInfo().then((userInfo: any) => {
          callCompteLoginExist({ Login: userInfo.preferred_username });
        });
    }
  }, [keycloakinitialized,keycloak.authenticated]);
  

  useEffect(() => {
    if (CompteLoginExistData?.Exist) { 
        setcurrentCompte(CompteLoginExistData.userName);
    } else {
        setcurrentCompte("");
    }
  }, [CompteLoginExistData])



  useEffect(() => {
    if (currentCompte!=="") {
      callUserByLogin(currentCompte);
    }
  }, [currentCompte])


  useEffect(() => {
    
    if (errorCompteLoginExist) {
      dispatch(setErrorCompte());
    }
    
    //keycloak.logout();
  }, [errorCompteLoginExist])

  
  if (!keycloakinitialized) {
    return <div>Loading...</div>;
  }

  return (
    <></>
    // <div>
    //   {!keycloak.authenticated ? (
    //     <p>Session expired. Redirecting to login...</p>
    //   ) : (
    //     <p>Session is active.</p>
    //   )}
    // </div>
  );
};

export default CpntKeycloakSession;
